import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyAtRgD5LlPRyudxu4RzmET5aCdaOWwFsJk",
  authDomain: "rsom-524c3.firebaseapp.com",
  databaseURL: "https://rsom-524c3.firebaseio.com",
  projectId: "rsom-524c3",
  storageBucket: "",
  messagingSenderId: "377910285655",
  appId: "1:377910285655:web:a91f1e1a91d59323"
};
firebase.initializeApp(firebaseConfig);
